import { InbodyType } from '../../../../shared/constants/inbody-info/InbodyType';
import { ValueOfKey } from '../../../../utils-types';

export const REPORT_MODE = {
  SINGLE: 'SINGLE',
  TREND: 'TREND',
} as const;

export type ReportMode = ValueOfKey<typeof REPORT_MODE>;

export type ProgressReportFormValues = {
  inbodyType: InbodyType | null;
  scanId: number | null;
  startScanId: number | null;
  endScanId: number | null;
};
